import { StudentCourse } from "@app/admin/model";

export class studentCourseLinks {
    studentCourseId: number;
    studentCourse: StudentCourse;
    skype: string;
}
